import apiEndpoints from 'const/endPoint'
import { AxiosRequestConfig, RawAxiosRequestHeaders } from 'axios'
import apiRequestor from 'services/apiRequestor'
import { getHeaderParams } from 'helpers/requestParams'
import config from 'const/config'

const { APIGEE_CLIENT_ID } = config

export interface GetAuthCodeParams {
  /**
   * Session ID from the eligibility check
   */
  sessionId: string
  /**
   * jwt from successful transmit response
   */
  jwtToken: string
}

export interface GetAuthCodeResponse {
  /** Necessary for Oauth token request */
  authCode: string
}

interface GetAuthCodeRequestSearchParams {
  /**
   * Session ID from the eligibility check
   */
  sessionId: string

  /**
   * Apigee client id
   */
  client_id: string
}

const authCodeAPI = {
  getAuthCode: async ({
    jwtToken,
    sessionId
  }: GetAuthCodeParams): Promise<GetAuthCodeResponse> => {
    const headers = {
      ...getHeaderParams(),
      jwtToken
    }

    const params: GetAuthCodeRequestSearchParams = {
      sessionId,
      client_id: APIGEE_CLIENT_ID
    }

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.getAuthCode,
      method: 'GET',
      headers: headers as RawAxiosRequestHeaders,
      params
    }

    const response = await apiRequestor<GetAuthCodeResponse>({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  }
}

export default authCodeAPI
